import { render, staticRenderFns } from "./ReceptionHistoryView.vue?vue&type=template&id=4d26bcdb"
import script from "./ReceptionHistoryView.vue?vue&type=script&lang=js"
export * from "./ReceptionHistoryView.vue?vue&type=script&lang=js"
import style0 from "./ReceptionHistoryView.vue?vue&type=style&index=0&id=4d26bcdb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports